if (!customElements.get('event-calendar')) {
  class EventCalendar extends HTMLElement {
    connectedCallback() {
      this.currentIndex = 0;
      this.totalMonths = parseInt(this.dataset.months) || 4;
      this.months = this.querySelectorAll('[data-month-index]');
      this.heading = this.querySelector('[data-calendar-title]');
      this.prevBtn = this.querySelector('[data-direction="-1"]');
      this.nextBtn = this.querySelector('[data-direction="1"]');
      this.activePopover = null;

      this.prevBtn.addEventListener('click', () => this.navigate(-1));
      this.nextBtn.addEventListener('click', () => this.navigate(1));

      this.addEventListener('click', (e) => {
        var link = e.target.closest('.calendar__event');
        if (!link) return;

        var title = link.querySelector('.calendar__event-title');
        if (title && title.scrollHeight <= title.clientHeight) return;

        e.preventDefault();
        e.stopPropagation();
        this.showPopover(link);
      });

      document.addEventListener('click', (e) => {
        if (this.activePopover && !this.activePopover.contains(e.target)) {
          this.dismissPopover();
        }
      });
    }

    navigate(direction) {
      var newIndex = this.currentIndex + direction;
      if (newIndex < 0 || newIndex >= this.totalMonths) return;

      this.months[this.currentIndex].hidden = true;
      this.currentIndex = newIndex;
      this.months[this.currentIndex].hidden = false;

      this.heading.textContent = this.months[this.currentIndex].dataset.monthName;
      this.prevBtn.disabled = this.currentIndex === 0;
      this.nextBtn.disabled = this.currentIndex === this.totalMonths - 1;
    }

    showPopover(link) {
      this.dismissPopover();

      var session = link.querySelector('.calendar__event-session');
      var popover = document.createElement('div');
      popover.className = 'calendar__popover';
      popover.style.background = link.style.background;
      popover.innerHTML =
        '<a href="' + link.href + '" class="calendar__popover-link">' +
        (session ? '<span class="calendar__popover-session">' + session.textContent + '</span>' : '') +
        link.getAttribute('title') + '</a>';

      link.closest('.calendar__day').insertBefore(popover, link);
      this.activePopover = popover;

      var calendarRect = this.getBoundingClientRect();
      var popoverRect = popover.getBoundingClientRect();
      if (popoverRect.right > calendarRect.right) {
        popover.style.left = 'auto';
        popover.style.right = '0';
      }
    }

    dismissPopover() {
      if (this.activePopover) {
        this.activePopover.remove();
        this.activePopover = null;
      }
    }
  }

  customElements.define('event-calendar', EventCalendar);
}
